import { Link } from "react-router-dom";

export default function MobileSticky() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-ink/90 backdrop-blur-lg border-t border-gold/25" data-testid="mobile-sticky">
      <div className="grid grid-cols-4 divide-x divide-gold/20">
        <a href="tel:3129331528" className="flex flex-col items-center justify-center py-3 text-hair text-bone/90 active:bg-gold/10" data-testid="sticky-call">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
          <span className="mt-1">Call</span>
        </a>
        <a href="sms:3129331528" className="flex flex-col items-center justify-center py-3 text-hair text-bone/90 active:bg-gold/10" data-testid="sticky-text">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
          <span className="mt-1">Text</span>
        </a>
        <Link to="/dog-training" className="flex flex-col items-center justify-center py-3 text-hair bg-gold text-ink font-semibold active:opacity-90" data-testid="sticky-book">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          <span className="mt-1">Book</span>
        </Link>
        <button
          onClick={() => document.querySelector('[data-testid="nav-menu-toggle"]')?.click()}
          className="flex flex-col items-center justify-center py-3 text-hair text-bone/90 active:bg-gold/10"
          data-testid="sticky-menu"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><line x1="3" y1="7" x2="21" y2="7"/><line x1="3" y1="17" x2="21" y2="17"/></svg>
          <span className="mt-1">Menu</span>
        </button>
      </div>
    </div>
  );
}
